// extracted by mini-css-extract-plugin
var _1 = "1010px";
var _2 = "840px";
var _3 = "432px";
var _4 = "1248px";
var _5 = "1536px";
export { _1 as "lg", _2 as "md", _3 as "sm", _4 as "xl", _5 as "xxl" }
